import { Injectable } from '@angular/core';
import { SearchDataService } from '@core/data/api/search/search-data.service';
import { SearchRequest } from '@core/data/api/search/search-request';
import { Observable } from 'rxjs';

@Injectable()
export class SearchService {
    constructor(
        private searchDataService: SearchDataService
    ) {}

    search(request: SearchRequest): Observable<any> {
        return this.searchDataService.search(request);
    }

    searchCompanies(keywords?: string, page?: number): Observable<any> {
        return this.searchDataService.searchCompanies(keywords, page);
    }

    searchIHDSites(query: string) {
        return this.searchDataService.searchIHDSites(query);
    }
}
